import React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { Base } from "../../framework/common/base";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { generatePath } from "react-router-dom";
import { LinkIconButton } from "../../framework/common/linkButton";
import { getLocalizedWeekDayName } from "../../i18n/i18n";
import { useTranslation } from "react-i18next";

interface DailyWorklogDateProps {
    date: string;
}

export const DailyWorklogDate = ({ date }: DailyWorklogDateProps) => {
    const { i18n } = useTranslation();
    const dateString = Base.dateToDateStr(date);
    const localizedWeekDay = getLocalizedWeekDayName(date, i18n.language);

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
            }}
        >
            <LinkIconButton
                to={generatePath("/worklog/:date", {
                    date: Base.dateToDateJSON(Base.dateAddDays(date, -1)),
                })}
            >
                <KeyboardArrowLeftIcon fontSize="large" color="success" />
            </LinkIconButton>
            <Typography
                variant="h2"
                sx={{ color: "primary.dark", textAlign: "center" }}
            >
                {localizedWeekDay} {dateString}
            </Typography>
            <LinkIconButton
                to={generatePath("/worklog/:date", {
                    date: Base.dateToDateJSON(Base.dateAddDays(date, 1)),
                })}
            >
                <KeyboardArrowRightIcon fontSize="large" color="success" />
            </LinkIconButton>
        </Box>
    );
};